import DialogMixin from "@/mixins/dialogMixin";
import {} from "@/utils/machineState";
import { mapActions, mapGetters } from "vuex";
import { MachineActions, MachineNamespace } from "@/store/machine";

export default {
  mixins: [DialogMixin],
  computed: {
    getSelectedDirection() {
      return this.$store.getters["machine/getDirection"];
    },

    ...mapGetters(MachineNamespace, [
      "getMachineList",
      "getRoadMapList",
      "getMachineId",
      "getMachineConnectionState",
    ]),
  },
  methods: {
    ...mapActions(MachineNamespace, { ...MachineActions }),

    setMachineDirection(direction) {
      this.$store.commit("machine/MUTATION_UPDATE_DIRECTION", direction);
    },
    // 머신 플레이어 생성
    async createMachinePlayer(
      machine_id,
      options = {
        isRedirect: true,
      }
    ) {
      console.log("createMachinePlayer");
      const player_id = this.$store.getters["auth/getPlayerId"];
      const external_token = this.$store.getters["auth/getExternalToken"];

      this.$store
        .dispatch("machine/ACTION_CREATE_MACHINE_PLAYER", {
          machine_id,
          player_id,
          external_token,
        })
        .then((res) => {
          // Handle case where res is undefined (network error / CORS)
          if (!res || !res.status) {
            this.showNotifyDialog({
              title: this.$t("notifyMessage.title"),
              text: "머신 플레이어 생성에 실패했습니다. 네트워크 연결을 확인해주세요.",
              btnText: this.$t("button.confirm"),
            });
            return;
          }

          switch (res.status) {
            case 200:
              {
                if (options.isRedirect) {
                  if (window.location.pathname === "/game") {
                    this.$router.replace({
                      path: "game",
                      query: { id: machine_id },
                    });
                  } else {
                    this.$router.push({
                      path: "game",
                      query: { id: machine_id },
                    });
                  }
                }
              }
              break;
            case 401:
              if (this.getPlayerId !== undefined) {
                this.$store.dispatch("auth/ACTION_AUTH_LOGOUT");
                // this.ACTION_AUTH_LOGOUT();
                //TODO: 공용 dialog로 이전 필요
                // this.openSignInDialog();
              }
              break;

            case 406:
              /**
               * 406 : The Player is using another machine.
               */
              this.showNotifyDialog({
                title: this.$t("notifyMessage.title"),
                text: this.$t("machine.error406"),
                btnText: this.$t("button.confirm"),
              });
              break;
            case 409:
              /**
               * 409 : There are no seats left.
               */
              this.showNotifyDialog({
                title: this.$t("notifyMessage.title"),
                text: this.$t("machine.error409"),
                btnText: this.$t("button.confirm"),
              });
              break;

            default:
              this.showNotifyDialog({
                title: this.$t("notifyMessage.title"),
                text: "request failed (code: " + res.status + ")",
                btnText: this.$t("button.confirm"),
              });
              break;
          }
        });
    },
  },
};
